import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { FormControl } from '@angular/forms';
import { ToastrUtil } from 'src/app/util/toastr.util';
import { MenuPrivilegeDialogComponent } from './menu-privilege-dialog/menu-privilege-dialog.component';
import { RolePrivilegeService } from 'src/app/services/role.privilege.service';

@Component({
  selector: 'app-privilege',
  templateUrl: './privilege.component.html',
  styleUrls: ['./privilege.component.scss']
})
export class PrivilegeComponent implements OnInit {

  public columnHeader: string[] = [
    'privilegeName',
    'privilegeDescription',
    'status',
    'action'
  ];

  public privilegeList: any[] = [];
  public toggle = new FormControl();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public dataSource = new MatTableDataSource();

  constructor(public rolePrivilegeService: RolePrivilegeService,
    public matDialog: MatDialog,
    public toaster: ToastrUtil) {
  }

  ngOnInit() {
    this.init();
  }

  init(): void {
    this.getAllPrivileges();
  }

  getAllPrivileges(): void {
    this.rolePrivilegeService.getAllPrivileges()
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          if (response.data && response.data.length > WebConstants.INT_ZERO) {
            this.privilegeList = response.data;

            this.dataSource = new MatTableDataSource(this.privilegeList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.privilegeList = [];
          }
        }
      });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onChange(element: any, checked: any): void {
    let privilegeObject = {
      id: element.id,
      name: element.name,
      description: element.description,
      status: (checked) ? WebConstants.STATUS.CODE.ACTIVE : WebConstants.STATUS.CODE.INACTIVE
    };

    this.rolePrivilegeService.updatePrivilege(privilegeObject)
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toaster.success("Privilege has been updated", "Success");

          this.getAllPrivileges();
        }
      });
  }

  openMenuPrivilegeDialog(element): void {
    const dialog = this.matDialog.open(MenuPrivilegeDialogComponent, {
      width: "1000px",
      data: element
    });

    dialog.afterClosed().subscribe(result => {
      this.init();
    });
  }
}